import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTemplatePreviewById, getIsLoading } from 'modules/templatePreview/selectors';
import { previewTemplate } from 'modules/templatePreview/actions';
import { removeScriptFullDoc } from 'utils/script';
import { cspTag } from 'modules/secureIframe';
import { IframeFullDoc } from 'modules/secureIframe';
import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';

const PreviewFrame = styled(IframeFullDoc)`
  width: 100%;
  pointer-events: none;
`;

type TemplatePreviewProps = {
  messageMedium: string;
  templateId: number;
};

export const TemplatePreview = ({ messageMedium, templateId }: TemplatePreviewProps) => {
  const dispatch = useDispatch();

  const isLoading = useSelector(getIsLoading);

  const previewHtml = useSelector((state) =>
    getTemplatePreviewById(state, {
      templateId,
      locale: undefined,
      showAndroid: false,
      showExpanded: false,
    }),
  );

  useEffect(() => {
    // don't run if we already stored the preview html.
    if (previewHtml) {
      return;
    }

    // i only want this to run once, on the first load.
    // if we don't query the first time...a retry won't help,
    // because something is borked with the html of the template
    dispatch(
      previewTemplate({
        templateId,
        messageMedium,
        showExpanded: false, // for push messages
        showLighthouseVersion: true, // for in-app, sms, push messages
      }),
    );
  }, []);

  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <PreviewFrame height={0} isMaxHeightPref>
      {removeScriptFullDoc(previewHtml, cspTag)}
    </PreviewFrame>
  );
};
